import React, { Component } from 'react';
import { Button, Modal, Row, Col, Label, } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import _ from "underscore";
const RemoveStopModal = (props) => {
    const { t } = useTranslation();
    return (React.createElement(Modal, { show: props.show, bsSize: "sm" },
        React.createElement(Modal.Header, null,
            React.createElement(Modal.Title, null,
                t('REMOVE_STOP_FROM_SHIPMENT'),
                "?")),
        React.createElement(Modal.Footer, null,
            React.createElement(Row, null,
                React.createElement(Col, { xs: 5 }),
                React.createElement(Col, { xs: 7 },
                    React.createElement("div", { className: "flex flex-row" },
                        React.createElement("button", { className: "button button-green hover:bg-green-dark text-white mr-2", onClick: () => {
                                props.removeStop();
                                props.onClose();
                            } }, t('CONFIRM')),
                        React.createElement("button", { className: "button bg-white text-grey hover:text-grey-darker", onClick: () => {
                                props.onClose();
                            } }, t('CANCEL'))))))));
};
export default RemoveStopModal;
